module.exports = __webpack_public_path__ + "img/15.c522ed9c.png";